<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="mb-12" cols="12">
        <b-card 
          header="Vuetable Alumno"  
          header-bg-variant="primary"
          header-text-variant="white" 
          class="table-responsive">
          <alumnos-filter-bar></alumnos-filter-bar>
          <vuetable ref="vuetable"
              api-url="api/alumnos"
              :http-options="httpOptions"
              :fields="fields"
              pagination-path=""
              :css="css.table"
              :sort-order="sortOrder"
              :multi-sort="true"
              :append-params="moreParams"
              :per-page="15"
              detail-row-component="alumnos-detail-row"
              @vuetable:cell-clicked="onCellClicked"
              @vuetable:pagination-data="onPaginationData"
          ></vuetable>
          <div class="vuetable-pagination">
              <vuetable-pagination-info 
                  ref="paginationInfo"
                  info-class="pagination-info" 
                  info-template="Mostrando {from} de {to} de {total} alumnos">
              </vuetable-pagination-info>
              <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
          </div>
        </b-card>
      </b-col>
     </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
import moment from 'moment'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import AlumnosDetailRow from './AlumnosDetailRow'
import AlumnosFilterBar from './AlumnosFilterBar'
import AlumnosActions from './AlumnosActions'

Vue.use(VueEvents)
Vue.component('alumnos-actions', AlumnosActions)
Vue.component('alumnos-detail-row', AlumnosDetailRow)

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    AlumnosFilterBar,    
  },   
  data () {
    return {
      httpOptions: { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } },
      fields: [
        {
          name: 'id',
          sortField: 'id',
        },
        {
          name: 'apellido',
          sortField: 'apellido',
        },
        {
          name: 'nombre',
          sortField: 'nombre',
        },
        {
          name: 'dni',
          sortField: 'dni',
          //visible: true,
        },
        {
          name: 'fec_nac',
          sortField: 'fec_nac',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: 'formatDate|DD-MM-YYYY',        
        },
        {
          name: 'direccion',
          sortField: 'direccion',
          visible: false,
        },
        {
          name: 'localidad',
          sortField: 'localidad',
          visible: false,
        },
        {
          name: 'telefono',
          sortField: 'telefono',
        },
        {
          name: 'nacionalidad',
          sortField: 'nacionalidad',
          callback:'evaluarNacionalidad'
        },        
        {
          name: '__component:alumnos-actions',
          title: 'Acciones',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],
      css: {
          table: {
            tableClass: 'table table-bordered table-striped table-sm ',
            loadingClass: 'loading',
            ascendingIcon: 'fa fa-chevron-up',
            descendingIcon: 'fa fa-chevron-down',
            detailRowClass: 'vuetable-detail-row',
            handleIcon: 'fa fa-shower',
          },
          pagination:{
            wrapperClass: "pagination pull-right",
            activeClass: "btn-primary",
            disabledClass: "disabled",
            pageClass: "btn btn-border",
            linkClass: "btn btn-border",
            icons: {
                first: "",
                prev: "",
                next: "",
                last: ""
            },
          },
      },
      sortOrder: [

        { field: 'apellido', sortField: 'apellido', direction: 'asc'}
      ],
      moreParams: {}
    }
  },
  methods: {
    
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    evaluarNacionalidad(value){
        return value;
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onCellClicked (data, field, event) {
      //console.log('cellClicked: ', field.name)
      this.$refs.vuetable.toggleDetailRow(data.id)
    },       
  }, 
  events: {
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'filter-reset' () {
      this.moreParams = {}
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'refrescarTabla'(){
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
      console.log('TABLA REFRESCADA')
    },   
  }

}
</script>
<style>
  .pagination {
    margin: 0;
    float: right;
  }
  .pagination a.page {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.page.active {
    color: white;
    background-color: #337ab7;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.btn-nav {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
  }
  .pagination a.btn-nav.disabled {
    color: lightgray;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
    cursor: not-allowed;
  }
  .pagination-info {
    float: left;
  }
  
table.vuetable {
     table-layout: auto;
}


.vuetable-body > tr > td {
     white-space: nowrap;
     overflow: hidden; 
     text-overflow: ellipsis; 
}


.vuetable th#_id {
     width: 80px;
}
.vuetable th#_action {
     width: 70px;
}

</style>
